/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const ReloadIcon = ({ width, height }) => {
  return (
    <svg
      version="1.1"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      height={`${height || '100%'}`}
      width={`${width || '100%'}`}
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
        enable-background: new 0 0 512 512;
      `}
    >
      <path
        d="M256.001,8.297C119.198,8.297,8.298,119.198,8.298,256.001s110.901,247.703,247.703,247.703  s247.704-110.901,247.704-247.703C503.703,119.198,392.804,8.297,256.001,8.297z"
        fill="#ffffff"
      />
      <path
        d="M256.001,426.265c-93.884,0-170.264-76.379-170.264-170.264c0-27.739,6.786-54.819,19.502-79.03  l-24.329-16.1L184.715,108.4L177,224.456l-25.265-16.719c-6.97,15.014-10.683,31.457-10.683,48.262  c0,63.384,51.567,114.951,114.951,114.951s114.951-51.567,114.951-114.951s-51.568-114.95-114.952-114.95V85.736  c93.884,0,170.264,76.379,170.264,170.264S349.885,426.265,256.001,426.265z"
        fill="#f9ad00"
      />
      <path
        d="M256,512c-51.694,0-101.514-15.345-144.074-44.375c-3.786-2.582-4.761-7.744-2.179-11.53  c2.582-3.786,7.741-4.764,11.531-2.179c39.794,27.142,86.38,41.489,134.723,41.489c63.948,0,124.068-24.902,169.285-70.12  s70.121-105.338,70.121-169.285c0-62.914-24.228-122.343-68.222-167.34c-3.204-3.277-3.145-8.529,0.132-11.733  c3.278-3.204,8.53-3.144,11.732,0.133c47.043,48.117,72.951,111.666,72.951,178.941c0,68.38-26.628,132.668-74.981,181.02  C388.668,485.372,324.381,512,256,512z M90.313,448.419c-1.979,0-3.964-0.704-5.55-2.132  C30.895,397.783,0.001,328.425,0.001,256.001c0-68.381,26.628-132.668,74.98-181.02S187.62,0,256,0  c57.663,0,112.113,18.725,157.461,54.149c3.611,2.821,4.251,8.036,1.43,11.647c-2.82,3.612-8.036,4.25-11.646,1.43  C360.844,34.102,309.925,16.594,256,16.594c-63.948,0-124.067,24.902-169.285,70.12s-70.12,105.338-70.12,169.286  c0,67.73,28.894,132.592,79.272,177.956c3.405,3.065,3.679,8.313,0.614,11.718C94.842,447.493,92.582,448.419,90.313,448.419z   M256,434.561c-98.459,0-178.561-80.102-178.561-178.561c0-26.244,5.894-52.416,17.102-76.16l-18.21-12.051  c-2.466-1.632-3.876-4.451-3.705-7.402c0.171-2.95,1.902-5.588,4.54-6.921l103.805-52.471c2.661-1.345,5.838-1.158,8.321,0.486  c2.486,1.644,3.897,4.496,3.7,7.47l-7.715,116.056c-0.196,2.95-1.947,5.572-4.595,6.884c-2.651,1.313-5.796,1.115-8.262-0.516  l-16.856-11.155c-4.13,11.492-6.217,23.486-6.217,35.779c0,58.808,47.844,106.654,106.654,106.654s106.654-47.845,106.654-106.654  S314.809,149.347,256,149.347c-4.583,0-8.297-3.715-8.297-8.297V85.736c0-4.582,3.714-8.297,8.297-8.297  c98.459,0,178.561,80.102,178.561,178.561S354.459,434.561,256,434.561z M97.398,161.832l12.419,8.219  c3.551,2.35,4.747,7.007,2.767,10.777c-12.136,23.108-18.551,49.102-18.551,75.172c0,89.308,72.659,161.967,161.967,161.967  s161.967-72.658,161.967-161.967c0-86.528-68.197-157.427-153.67-161.757v38.786C328.403,137.311,379.248,190.83,379.248,256  c0,67.958-55.289,123.248-123.248,123.248S132.752,323.959,132.752,256c0-17.969,3.854-35.382,11.455-51.757  c1.018-2.192,2.94-3.831,5.267-4.49c2.325-0.658,4.822-0.27,6.838,1.064l13.355,8.837l5.802-87.286L97.398,161.832z"
        fill="#ffffff"
      />
    </svg>
  );
};

export default ReloadIcon;

ReloadIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
};
